
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [{
label: '征免性质简称',
value: this.$route.params.Item.PE_Name_Abbr
}, {
label: '征免性质全称',
value: this.$route.params.Item.PE_Name_All
}, {
label: '征免性质说明',
value: this.$route.params.Item.PE_Remark
}]
}
}



// WEBPACK FOOTER //
// ./src/components/ExemptionNatureDetail.vue